import { ColorPickerField } from '@/components/Configuracao/AppearanceColorPickerField'
import type { AppearanceThemeProps } from '@/components/Configuracao/appearanceTypes'

export function AppearanceTypographyTab({ draft, updateDraft }: AppearanceThemeProps) {
  const colorFields = [
    { key: 'fontColorH1' as const, label: 'H1 — Títulos Principais', preview: 'Título Principal' },
    { key: 'fontColorH2' as const, label: 'H2 — Subtítulos', preview: 'Subtítulo da Seção' },
    { key: 'fontColorH3' as const, label: 'H3 — Headers de Seção', preview: 'Header de Seção' },
    { key: 'fontColorH4' as const, label: 'H4 — Subseção', preview: 'Subseção' },
    { key: 'fontColorH5' as const, label: 'H5 — Tópico', preview: 'Tópico' },
    { key: 'fontColorH6' as const, label: 'H6 — Subtópico', preview: 'Subtópico' },
    { key: 'fontColorBody' as const, label: 'Body — Texto Corpo', preview: 'Texto de corpo padrão do sistema' },
    { key: 'fontColorMuted' as const, label: 'Muted — Texto Secundário', preview: 'Texto secundário e descrições' },
    { key: 'fontColorLabel' as const, label: 'Label — Captions e Labels', preview: 'LABEL UPPERCASE' },
  ]

  const sizeFields = [
    { key: 'fontSizeHero' as const, label: 'Hero' },
    { key: 'fontSizeH1' as const, label: 'H1' },
    { key: 'fontSizeH2' as const, label: 'H2' },
    { key: 'fontSizeH3' as const, label: 'H3' },
    { key: 'fontSizeH4' as const, label: 'H4' },
    { key: 'fontSizeH5' as const, label: 'H5' },
    { key: 'fontSizeH6' as const, label: 'H6' },
    { key: 'fontSizeBody' as const, label: 'Body' },
    { key: 'fontSizeSm' as const, label: 'Small' },
    { key: 'fontSizeXs' as const, label: 'Extra Small' },
    { key: 'fontSizeLabel' as const, label: 'Label' },
  ]

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Colors */}
      <div className="glass-card p-5 space-y-4">
        <h3 className="text-text-primary font-semibold text-sm">Cores da Tipografia</h3>
        {colorFields.map((field) => (
          <div key={field.key} className="flex items-center gap-4">
            <div className="flex-1">
              <ColorPickerField
                label={field.label}
                value={draft[field.key] as string}
                onChange={(v) => updateDraft({ [field.key]: v })}
              />
            </div>
            <div
              className="mt-5 font-medium text-sm"
              style={{ color: draft[field.key] as string }}
            >
              {field.preview}
            </div>
          </div>
        ))}
      </div>

      {/* Sizes */}
      <div className="glass-card p-5 space-y-4">
        <h3 className="text-text-primary font-semibold text-sm">Tamanhos da Tipografia</h3>
        <div className="grid grid-cols-2 gap-3">
          {sizeFields.map((field) => (
            <div key={field.key} className="flex items-center gap-3">
              <div className="flex-1 flex flex-col gap-1.5">
                <label className="text-text-muted text-[11px] font-medium uppercase tracking-wider">{field.label}</label>
                <input
                  type="text"
                  value={draft[field.key] as string}
                  onChange={(e) => updateDraft({ [field.key]: e.target.value })}
                  placeholder="ex: 1rem"
                  className="bg-white/[0.04] border border-white/[0.06] text-text-primary rounded-md px-3 py-2 text-xs font-mono outline-none focus:border-accent transition-colors"
                />
              </div>
              <div
                className="mt-5 text-text-body whitespace-nowrap"
                style={{ fontSize: draft[field.key] as string }}
              >
                Aa
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
